import React, {Component} from 'react';
import {Button, Modal, Form, Grid} from 'semantic-ui-react';
import update from 'react-addons-update';

import IngredientData from "../../data/IngredientData";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {ingredientDialog} from "../../actions/IngredientDialogAction";
import {selectIngredient} from "../../actions/IngredientSelectAction";
import localDB from "../../data/localDB";
import helpers from "../../functions/helpers";
import {providerDialog} from "../../actions/ProviderDialogAction";
import {selectProvider} from "../../actions/ProviderSelectAction";

const C = require("../../constants");

class IngredientDialog extends Component {

    constructor() {
        super();

        this.state = {
            ingredient: {
                name: '',
                id: null,
                provider: null,
                unit: null,
                sell_negative: true,
                price: 0,
                min_stock: 0
            },
            providers:[],
            units: C.UNITS,
            name_error: false,
            price_error: false,
            unit_error: false,
            loading: false
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleProviderChange = this.handleProviderChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleStock = this.handleStock.bind(this);
        this.handleMinStockChange = this.handleMinStockChange.bind(this)

    }

    async componentDidMount() {
        await this.initialFetch()
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.ingredient_dialog){
            this.setState({ingredient: nextProps.ingredient_dialog.ingredient});
        }
        if(nextProps.provider_select && nextProps.provider_select.id){
            let text = nextProps.provider_select.factory ? `${nextProps.provider_select.full_name} - ${nextProps.provider_select.factory}`:nextProps.provider_select.full_name;
            let provider = {key:nextProps.provider_select.id, text, value:nextProps.provider_select.id};
            let providers = update(this.state, {
                providers: {$set: this.state.providers.push(provider)}
            });
            this.setState(providers);
            this.handleProviderChange(provider.key);
        }
    }

    async initialFetch() {
        let providers = helpers.mapProviders(await localDB.getDB('providers'));
        providers.unshift({key: null, value: null, text: 'Ninguno'});
        this.setState({providers});
    }

    handleNameChange = (event) => {
        let name = update(this.state, {
            ingredient: {
                name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(name);
        if (event.target.value.trim() === '') {
            this.setState({name_error: true})
        } else {
            this.setState({name_error: false});
        }
    };

    handlePriceChange = (event) => {
        let price = update(this.state, {
            ingredient: {
                price: {
                    $set: event.target.value
                }
            }
        });
        this.setState(price);
        if (event.target.value.trim() === '') {
            this.setState({price_error: true})
        } else {
            this.setState({price_error: false});
        }
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.ingredient.name === '') {
            this.setState({name_error: true});
        }else if (this.state.ingredient.unit === '') {
            this.setState({unit_error: true});
        } else {
            this.setState({disabledButton: true, loading:true});
            let data = this.state.ingredient
            data.min_stock = data.min_stock === '' ? 0:data.min_stock
            if (this.state.ingredient.id) {
                IngredientData.update(this.state.ingredient, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Ingrediente Actualizado!');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({disabledButton: false, open: false, loading:false});
                });
            } else {
                IngredientData.add(this.state.ingredient, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Ingrediente Agregado!');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
                    }
                    this.setState({disabledButton: false, open: false, loading:false});
                });
            }
        }
    };

    handleClose = () => {
        this.props.selectProvider({id:null, full_name:''});
        this.props.ingredientDialog({open:false, ingredient:{id:null, name:'', price: 0, stock: false, unit:null, min_stock:0}});
    };

    handleProviderChange = (result) => {
        let provider = update(this.state, {
            ingredient: {
                provider: {$set: result}
            }
        });
        this.setState(provider);
    };

    handleUnitChange = (result) => {
        let unit = update(this.state, {
            ingredient: {
                unit: {$set: result}
            }
        });
        this.setState(unit);
    };

    handleStock = () => {
        let stock = update(this.state, {
            ingredient: {
                stock: {
                    $set: !this.state.ingredient.stock
                }
            }
        });
        this.setState(stock);
    };

    handleSellNegative = () => {
        let sell_negative = update(this.state, {
            ingredient: {
                sell_negative: {
                    $set: !this.state.ingredient.sell_negative
                }
            }
        });
        this.setState(sell_negative);
    };

    dispatchData = (ingredient, message) => {
        this.props.selectProvider({id:null, full_name:''});
        this.props.ingredientDialog({open:false, ingredient:{id:null, name:'', price: 0, stock: false, min_stock:0, unit:{value:null}}});
        this.props.selectIngredient(ingredient);
        this.props.showToast({message: message, type: 'success'});
    };

    handleMinStockChange = (event) => {
        let min_stock = update(this.state, {
            ingredient: {
                min_stock: {
                    $set: event.target.value
                }
            }
        });
        this.setState(min_stock);
    };

    handleAddProvider = (e, { value }) => {
        this.props.providerDialog({open:true, provider:{id: null, full_name: value, provider:null, factory:'', email:'', phone:'', phone_prefix:'+57'}});
    };

    render() {
        return (
            <div>
                <Modal size='small' dimmer='inverted' open={this.props.ingredient_dialog.open} onClose={this.handleClose}>
                    <Modal.Header>{this.props.ingredient_dialog.ingredient.id ? 'Actualizar Ingrediente':'Nuevo Ingrediente'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid stackable>
                                    <Grid.Row columns={2}>
                                        <Grid.Column>
                                            <Form.Input label='Nombre' placeholder='Nombre'
                                                        value={this.state.ingredient.name}
                                                        onChange={this.handleNameChange}
                                                        error={this.state.name_error}/>
                                            <Form.Input label='Precio' placeholder='Precio' type='number'
                                                        value={this.state.ingredient.price}
                                                        onChange={this.handlePriceChange}
                                                        error={this.state.price_error}/>
                                            <Form.Checkbox label='Control de inventarios'
                                                           checked={this.state.ingredient.stock}
                                                           onChange={this.handleStock}/>
                                            {this.state.ingredient.stock ? <Form.Input label='Inventario Mínimo' placeholder='Inventarion Mínimo' type='number' value={this.state.ingredient.min_stock}
                                                                                 onChange={this.handleMinStockChange} />:null}
                                            {this.state.ingredient.stock ?<Form.Checkbox label='Vender en negativo'
                                                           checked={this.state.ingredient.sell_negative}
                                                           onChange={this.handleSellNegative}/>:null}
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Form.Select noResultsMessage='No hay resultados'
                                                         label='Unidad'
                                                         search
                                                         options={this.state.units}
                                                         value={this.state.ingredient.unit}
                                                         error={this.state.unit_error}
                                                         onChange={(e, { value }) => this.handleUnitChange(value)}
                                                         placeholder='Unidad' />
                                            <Form.Select label='Proveedor'
                                                         search allowAdditions
                                                         options={this.state.providers}
                                                         value={this.state.ingredient.provider ? this.state.ingredient.provider : ''}
                                                         additionLabel={<i style={{ color: '#e44745' }}>Nuevo Proveedor: </i>}
                                                         onAddItem={this.handleAddProvider}
                                                         onChange={(e, { value }) => this.handleProviderChange(value)}
                                                         placeholder='Proveedor' />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save'
                                labelPosition='left'
                                onClick={this.handleSubmit}
                                disabled={this.state.loading}
                                loading={this.state.loading}
                                content={this.props.ingredient_dialog.ingredient.id ? 'Actualizar':'Guardar'}/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ingredient_dialog: state.get('ingredient_dialog'),
        provider_select: state.get('provider_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        ingredientDialog(data) {
            dispatch(ingredientDialog(data));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectIngredient(data){
            dispatch(selectIngredient(data))
        },
        providerDialog(data){
            dispatch(providerDialog(data))
        },
        selectProvider(data){
            dispatch(selectProvider(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IngredientDialog);


// WEBPACK FOOTER //
// ./src/components/inventories/IngredientDialog.js